import React, { useState, useEffect } from 'react';
import { collection, getDocs, updateDoc, deleteDoc, doc } from 'firebase/firestore';
import { storage, db } from '../firebase';
import NavbarAdmin from '../components/NavbarAdmin';
import './styles/ManageStatDom.css';
import { deleteObject, ref } from 'firebase/storage'
const ManageProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'projects'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProjects(data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)));
      } catch (error) {
        console.error("Error fetching documents: ", error);
      }
    };

    fetchProjects();
  }, []);
 const handleDelete = async (id, photoUrl) => {
  const confirmDelete = window.confirm("Êtes-vous sûr de vouloir supprimer ce projet ?");
  if (confirmDelete) {
    try {
      const photoPath = photoUrl.split('/o/')[1].split('?')[0].replace('%2F', '/');
      const photoRef = ref(storage, `${photoPath}`);

      // Check if the file exists before deleting
     // const fileExists = await photoRef.getMetadata().then(() => true).catch(() => false);
    try {
        await deleteObject(photoRef);
         
} catch (error) {
    
  }


      await deleteDoc(doc(db, 'projects', id));
      alert("Projet supprimé avec succès!");

      const querySnapshot = await getDocs(collection(db, 'projects'));
      const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProjects(data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)));
    } catch (error) {
      console.error("Error deleting document or photo: ", error);
    }
  }
};

  const handleStatusChange = async (id) => {
    const confirmStatusChange = window.confirm("Êtes-vous sûr de vouloir marquer ce projet comme terminé ?");
    if (confirmStatusChange) {
      try {
        const projectRef = doc(db, 'projects', id);
        await updateDoc(projectRef, { status: 1 });

        // Refetch data to update the table
        const querySnapshot = await getDocs(collection(db, 'projects'));
        const data = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setProjects(data.sort((a, b) => new Date(a.startDate) - new Date(b.startDate)));
      } catch (error) {
        console.error("Error updating document: ", error);
      }
    }
  };
  const headingStyle = {
    fontSize: '2rem', 
    color: '#cc6699',
    fontFamily: 'Chalkboard, Comic Sans MS, cursive, sans-serif',
    margin: '20px 0', 
    textAlign: 'center', 
    borderBottom: '2px solid #ddd',
    paddingBottom: '10px' 
  };


  return (
    <div>
      <NavbarAdmin />
      <div className="manage-statistics">
      <h2 style={headingStyle}>Gérer les Projets</h2>
        <table>
          <thead>
            <tr>
              <th>Titre</th>
              <th>Etat</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(project => (
              <tr key={project.id}>
                <td>{project.title}</td>
                <td>{project.status === 0 ? "projet en cours" : "projet réalisé"}</td>
                <td>
                  {project.status === 0 && (
                    <button
                      onClick={() => handleStatusChange(project.id)}
                      className="modifier"
                    >
                      Terminer
                    </button>
                  )}
              &nbsp;&nbsp;  <button
                    onClick={() => handleDelete(project.id, project.photo)}
                     className="supprimer"
                  >
                    Supprimer
                  </button>
                  
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ManageProjects;
